import {
  STATUS_FAIL,
  STATUS_SUCCESS,
  SYSTEM_ERROR,
  SAVED_LISTS_PAGE_PATH,
  SAVED_LISTS_FORM_NAME
} from 'constants/analyticsConstants';
import { format } from 'date-fns/format';
import { DATE_FORMAT_MM_DD_YY } from './_constants/common';

const formatDate = (date: string) => {
  if (date !== '') {
    const formatedDate = format(new Date(date), DATE_FORMAT_MM_DD_YY);
    return formatedDate;
  }
  return '';
};

const displayFormContentValues = ({
  itemPartNumber = '',
  startDate = '',
  endDate = ''
}: {
  itemPartNumber: string;
  startDate: string;
  endDate: string;
}) => {
  return `Item: ${itemPartNumber} |  Date:${formatDate(startDate)} ${formatDate(endDate)}`;
};
export const getFormSubmitEvent = ({
  formContent,
  formContent2,
  formStatus,
  formFieldCausingError
}: {
  formContent: string;
  formContent2: string;
  formStatus: string;
  formFieldCausingError: string;
}) => {
  return {
    event: 'formSubmitted',
    pagePath: SAVED_LISTS_PAGE_PATH,
    formName: SAVED_LISTS_FORM_NAME,
    formContent: formContent,
    formContent2: formContent2,
    formStatus: formStatus,
    formFieldCausingError: formFieldCausingError,
    formLocation: ''
  };
};
export const getSearchResultsFormEvent = ({
  savedListsLength,
  itemPartNumber,
  startDate,
  endDate
}: {
  savedListsLength: number;
  itemPartNumber: string;
  startDate: string;
  endDate: string;
}) => {
  return getFormSubmitEvent({
    formContent: displayFormContentValues({
      itemPartNumber,
      startDate,
      endDate
    }),
    formContent2: `Results:${savedListsLength}`,
    formStatus: STATUS_SUCCESS,
    formFieldCausingError: ''
  });
};

export const gaSearchValidationError = ({
  itemPartNumber,
  startDate,
  endDate
}: {
  itemPartNumber: string;
  startDate: string;
  endDate: string;
}) => {
  return getFormSubmitEvent({
    formContent: displayFormContentValues({
      itemPartNumber,
      startDate,
      endDate
    }),
    formContent2: '',
    formStatus: STATUS_FAIL,
    formFieldCausingError: SYSTEM_ERROR
  });
};
